import { denormalize } from 'normalizr';
import { Selector, createSelector } from 'reselect';

import { Link as BBLink, Project, Workspace } from 'src/components/types';
import { project as projectSchema } from 'src/sections/repository/schemas';
import { BucketState } from 'src/types/state';

import { getEntities, getProject } from './state-slicing-selectors';

export type ProjectSelector<T> = Selector<BucketState, T>;

export const getCurrentProjectID: ProjectSelector<string | null | undefined> =
  createSelector(getProject, project => project?.section?.currentProject);

export const getCurrentProject: ProjectSelector<Project | undefined> =
  createSelector(getCurrentProjectID, getEntities, (key, entities) =>
    denormalize(key, projectSchema, entities)
  );

export const getCurrentProjectKey: ProjectSelector<string | undefined> =
  createSelector(getCurrentProject, project => project?.key);

export const getCurrentProjectUuid: ProjectSelector<string | undefined> =
  createSelector(getCurrentProject, project => project?.uuid);

export const getCurrentProjectWorkspace: ProjectSelector<
  Workspace | undefined
> = createSelector(getCurrentProject, project => project?.workspace);

export const getCurrentProjectWorkspaceSlug: ProjectSelector<
  string | undefined
> = createSelector(getCurrentProject, project => project?.workspace?.slug);

export const getCurrentProjectWorkspaceUuid: ProjectSelector<
  string | undefined
> = createSelector(getCurrentProject, project => project?.workspace?.uuid);

export const getIsCurrentProjectPrivate: ProjectSelector<boolean | undefined> =
  createSelector(getCurrentProject, project => project?.is_private);

export const getCurrentProjectLinkData: ProjectSelector<{
  name?: string;
  links?: {
    avatar: BBLink;
    html: BBLink;
    repositories?: BBLink;
    self: BBLink;
  };
}> = createSelector(getCurrentProject, currentProject =>
  currentProject
    ? {
        name: currentProject.name,
        links: currentProject.links,
      }
    : {}
);
